import { Brand } from "@components/swagmagic/dynamic/slices/brand-carousel";
import { CE_05, CUSTOM, getCarouselSlidesPerRow, ViewType } from "@helpers/plasmic/slices";

export const getBrandsCarouselData = ({
  fetchedBrands = [],
  viewType,
  customBrands = [],
  visibleBrandCount,
}: {
  fetchedBrands?: Brand[];
  viewType: ViewType;
  customBrands?: Brand[];
  visibleBrandCount?: number;
}) => {
  const defaultSlidesPerRow = getCarouselSlidesPerRow(CE_05);
  const hasFetchedBrands = fetchedBrands.length > 0;

  if (!hasFetchedBrands) {
    return { brandsToRender: [], defaultSlidesPerRow, hasBrands: false };
  }

  let brandsToShow: Brand[];

  if (viewType === CUSTOM) {
    const fetchedBrandsByKey = new Map(fetchedBrands.map((brand) => [brand.key, brand]));
    brandsToShow =
      customBrands
        ?.filter((brand) => brand.key && brand.name && fetchedBrandsByKey.has(brand.key))
        .map((customBrand) => ({
          ...fetchedBrandsByKey.get(customBrand.key)!,
          ...customBrand,
        })) ?? [];
  } else {
    brandsToShow = fetchedBrands;
  }

  const brandsToRender = visibleBrandCount
    ? brandsToShow.slice(0, visibleBrandCount)
    : brandsToShow;

  const hasBrands = brandsToRender.length > 0;

  return { brandsToRender, defaultSlidesPerRow, hasBrands };
};
